// extracted by mini-css-extract-plugin
export default {"DetailRating":"DetailRating_DetailRating__OWJlM"};